import { render, staticRenderFns } from "./MessengerPlatformIcon.vue?vue&type=template&id=cfd61838&scoped=true"
import script from "./MessengerPlatformIcon.vue?vue&type=script&lang=js"
export * from "./MessengerPlatformIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfd61838",
  null
  
)

export default component.exports